import { Component } from '@angular/core';

@Component({
  selector: 'app-site-map',
  template: `
    <div id="siteMap">
      <ul style="list-style:outside">
        <li><a [routerLink]="['/']">Home</a></li>
        <li><a [routerLink]="['/aboutus']">About IR/AR</a></li>
        <li>Search</li>
        <li>
          <img src="../images/spacer.gif" height="1" width="20" alt="" border="0" />
          <a [routerLink]="['/mapsearch']">Map Search</a>
        </li>
        <li>
          <img src="../images/spacer.gif" height="1" width="20" alt="" border="0" />
          <a [routerLink]="['/advancedsearch']">Advanced Search</a>
        </li>
        <li><a [routerLink]="['/abbreviations']">Abbreviations List</a></li>
        <li><a [routerLink]="['/contactus']">Contact Us</a></li>
        <li><a [routerLink]="['/links']">Links of Interest</a></li>
        <li><a [routerLink]="['/sitemap']">Site Map</a></li>
      </ul>
    </div>
  `
})
export class SiteMapComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/site-map.ts